import roleFacet from '~/modules/common/components/SearchBox/Facets/RoleFacet';
import AllocatedResourceFacet from '~/modules/common/components/SearchBox/Facets/ProjectResourceFacet';
import ResourcePoolFacet from '~/modules/common/components/SearchBox/Facets/ResourcePoolFacet';
import { ProjectResourceFacet } from '~/modules/common/components/SearchBox/Facets/UserFacet';

const getFacets = ({ projectId, isPSAActualCornerCasesEnabled }) => [
  isPSAActualCornerCasesEnabled
    ? ProjectResourceFacet
    : AllocatedResourceFacet(projectId),
  roleFacet,
  ResourcePoolFacet
];

export default getFacets;
